import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaiairportcabservice() {



const cardData = {
  keyword: " Mumbai Airport Cab Service ",

headingDescription: "Velocity Cab provides reliable and comfortable Mumbai Airport cab services, ensuring smooth and hassle-free pickups and drop-offs to and from Chhatrapati Shivaji Maharaj International Airport. Our professional drivers, well-maintained vehicles, and punctual service make airport travel convenient for business travelers, families, and tourists. We offer flexible booking options including one-way transfers, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for all travel needs. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Mumbai Airport cab service.",

topPlaces: [

  {
    title: "Bhandardara",
    description: "Bhandardara is a tranquil hill retreat known for Arthur Lake, Randha Falls, and Wilson Dam. Nature lovers can enjoy breathtaking landscapes, camping, and peaceful surroundings, making it a perfect weekend getaway from Mumbai."
  },
  {
    title: "Jawhar",
    description: "Jawhar is a charming hill station in Maharashtra famous for its waterfalls, lush forests, and tribal culture. Visitors can explore Jai Vilas Palace, Dabhosa Waterfall, and Hanuman Point while enjoying a refreshing escape from city life."
  },
  {
    title: "Kolad",
    description: "Kolad is an adventure destination near Mumbai renowned for white-water rafting on the Kundalika River. Travelers can also enjoy kayaking, ziplining, and camping, making it an excellent destination for thrill seekers."
  },
  {
    title: "Harihareshwar",
    description: "Harihareshwar is a peaceful coastal town known for its pristine beaches and the ancient Harihareshwar Temple. It offers a perfect blend of spirituality, scenic beauty, and relaxing seaside experiences."
  },
  {
    title: "Diveagar",
    description: "Diveagar is a serene beach destination featuring golden sands, coconut groves, and a peaceful atmosphere. It is ideal for families and couples looking to unwind by the Arabian Sea."
  },
    {
    title: "Lavasa",
    description: "Lavasa is a picturesque planned hill city surrounded by the Sahyadri Hills, offering beautiful lakeside views, colorful architecture, and adventure activities. Travelers booking a sedan cab from Mumbai can enjoy a scenic drive and relax with boating, cycling, and waterfront walks."
  },
  {
    title: "Murud-Janjira",
    description: "Murud-Janjira is famous for the magnificent Janjira Fort built on an island in the Arabian Sea. Visitors can enjoy boat rides to the fort, explore its fascinating history, and relax on the nearby beaches."
  },
  {
    title: "Tarkarli",
    description: "Tarkarli is one of Maharashtra’s most beautiful beach destinations, known for crystal-clear waters, scuba diving, snorkeling, and houseboat experiences. It is a paradise for beach lovers and water sports enthusiasts."
  },
  {
    title: "Ganpatipule",
    description: "Ganpatipule is a popular pilgrimage and beach destination famous for the self-originated Ganpati Temple and its pristine coastline. Travelers can enjoy spiritual visits along with relaxing beach experiences."
  },
  {
    title: "Amboli",
    description: "Amboli is a scenic hill station in the Western Ghats known for mist-covered hills, waterfalls, dense forests, and pleasant weather. It is an excellent destination for nature lovers, photographers, and monsoon travelers."
  }
],



services: [
{
name: "Mumbai Airport Taxi Service",
description: "Mumbai Airport taxi service offers reliable and hassle-free transportation for arrivals and departures at Chhatrapati Shivaji Maharaj International Airport. This service is ideal for business travelers, families, and tourists looking for comfortable airport transfers. Professional drivers ensure timely pickup and drop, helping passengers avoid delays and travel stress. Vehicles are clean, well-maintained, and equipped with modern amenities for a smooth ride. Customers can choose from sedan, SUV, and premium cars based on their travel needs. Real-time flight tracking ensures drivers adjust pickup timing according to flight schedules. With transparent pricing and easy booking, this service guarantees a seamless airport travel experience."
},
{
name: "Cab from Mumbai Airport",
description: "Cab from Mumbai Airport provides convenient transportation for travelers heading to different parts of the city or nearby destinations. This service ensures quick availability of vehicles with professional drivers for safe travel. Door-to-door service eliminates the hassle of finding transport after landing. Multiple vehicle options are available for different budgets. It is a reliable choice for airport transfers. It ensures comfort and convenience."
},
{
name: "Mumbai Airport Pickup Cab",
description: "Mumbai Airport pickup cab service ensures timely pickup from airport terminals with drivers waiting at designated points. This service is ideal for passengers arriving in Mumbai who want a smooth transfer to their destination. Drivers monitor flight timings to avoid delays. Spacious vehicles provide comfort for passengers and luggage. Flexible booking options are available. It ensures a stress-free arrival experience."
},
{
name: "Mumbai Airport Drop Taxi",
description: "Mumbai Airport drop taxi service offers reliable transportation for passengers traveling to the airport for departures. This service ensures timely pickup from home or hotel to avoid missing flights. Professional drivers plan routes efficiently considering traffic conditions. Comfortable vehicles enhance the travel experience. Flexible scheduling options are available. It ensures a smooth and punctual airport drop."
},
{
name: "Mumbai Airport Transfer Cab",
description: "Mumbai Airport transfer cab service provides seamless transportation between airport terminals and city locations. This service is ideal for business travelers and tourists requiring quick and comfortable transfers. Vehicles are well-maintained and drivers are experienced in handling airport routes. Flexible pickup and drop options add convenience. It is suitable for both arrival and departure transfers. It ensures a hassle-free journey."
},
{
name: "Cheap Mumbai Airport Cab",
description: "Cheap Mumbai Airport cab offers budget-friendly travel options without compromising comfort and safety. This service is perfect for cost-conscious travelers looking for reliable airport transportation. Economical sedan options are available for lower fares. Transparent pricing ensures no hidden charges. Professional drivers ensure safe travel. It is a perfect choice for affordable airport transfers."
},
{
name: "Mumbai Airport Taxi Booking Online",
description: "Mumbai Airport taxi booking online allows customers to reserve cabs quickly with instant confirmation and flexible scheduling. Online platforms provide easy booking with secure payment options. Customers can select vehicle type, pickup time, and location conveniently. Transparent pricing ensures clarity in fares. Dedicated support is available for assistance. It is the most convenient way to book airport taxis."
},
{
name: "Private Cab Mumbai Airport",
description: "Private cab Mumbai Airport offers exclusive travel experience with dedicated vehicles for passengers. This service is ideal for families and business travelers who prefer privacy and comfort. Travelers can customize pickup and drop locations based on their needs. Professional drivers ensure safe and reliable service. Comfortable seating and clean interiors enhance the experience. It ensures a premium airport transfer."
},
{
name: "AC Taxi Mumbai Airport",
description: "AC taxi Mumbai Airport ensures a comfortable journey in air-conditioned vehicles for airport transfers. This service is ideal for all weather conditions, providing a pleasant travel environment. Clean interiors and well-maintained AC systems enhance passenger comfort. Flexible pickup options add convenience. Professional drivers ensure timely service. It guarantees a relaxing airport travel experience."
},
{
name: "SUV Cab Mumbai Airport",
description: "SUV cab Mumbai Airport is ideal for group travel and passengers with extra luggage. SUVs provide spacious seating and better comfort for airport transfers. This service is suitable for families, corporate travelers, and tourists. Professional drivers ensure safe and smooth travel. Flexible booking options are available. It offers a premium and comfortable airport ride."
},
{
name: "Mumbai Airport to City Cab",
description: "Mumbai Airport to city cab service provides quick and reliable transportation from airport terminals to different city locations. This service ensures smooth travel with professional drivers familiar with city routes. Travelers can enjoy door-to-door service without any hassle. Multiple vehicle options are available for different budgets. Flexible booking options make it convenient. It ensures a comfortable and efficient transfer."
}
],

tableData: [
["Mumbai Airport Taxi Service","Cab from Mumbai Airport"],
["Mumbai Airport Pickup Cab","Mumbai Airport Drop Taxi"],
["Mumbai Airport Transfer Cab","Cheap Mumbai Airport Cab"],
["Mumbai Airport Taxi Booking Online","Private Cab Mumbai Airport"],
["AC Taxi Mumbai Airport","SUV Cab Mumbai Airport"],
["Mumbai Airport to City Cab","Mumbai Airport Taxi Service"]
],


whychoose: [
  {
    WhyChooseheading: "Reliable Airport Transfers",
    WhyChoosedescription: "Velocity Cabs offers dependable Mumbai Airport cab service for timely pickup and drop at both domestic and international terminals, ensuring stress-free airport travel."
  },
  {
    WhyChooseheading: "Experienced Airport Drivers",
    WhyChoosedescription: "Our drivers are well experienced with Mumbai Airport routes, terminals, and traffic patterns, ensuring smooth navigation and on-time arrivals for flights."
  },
  {
    WhyChooseheading: "Transparent Airport Pricing",
    WhyChoosedescription: "Velocity Cabs provides clear and transparent pricing for Mumbai Airport cab bookings. Customers receive complete fare details including toll charges and parking if applicable."
  },
  {
    WhyChooseheading: "24/7 Airport Cab Availability",
    WhyChoosedescription: "Our Mumbai Airport cab service operates 24/7, allowing customers to book rides anytime for early morning departures or late-night arrivals."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well maintained, and regularly cleaned to provide a comfortable airport travel experience."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for individuals, families, and group airport transfers."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, railway stations, and business locations across Mumbai for seamless airport transfers."
  },
  {
    WhyChooseheading: "Trusted Airport Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Mumbai Airport cab bookings due to punctual drivers, comfortable vehicles, and professional service."
  }
]
};

const faqData = [
  { question: "Do you provide Mumbai Airport cab service?", answer: "Yes, Velocity Cabs provides reliable cab services for Mumbai Airport pickup and drop." },
  { question: "Is airport cab service available 24 hours?", answer: "Yes, our Mumbai Airport cab service operates 24/7 for all flight schedules." },
  { question: "Which terminals are covered?", answer: "We provide cab service for all terminals including Terminal 1 and Terminal 2 of Mumbai Airport." },
  { question: "Which vehicles are available for airport transfer?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way airport cab?", answer: "Yes, we provide one-way airport pickup and drop services." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Can I book airport cab online?", answer: "Yes, customers can easily book Mumbai Airport cab services online or through phone booking." },
  { question: "Do you provide pickup from home or hotel?", answer: "Yes, we provide doorstep pickup from homes, hotels, and offices across Mumbai." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended especially during peak travel hours." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Arjun Mehta",
    feedback:
      "The Mumbai Airport cab service was very reliable and punctual. The pickup was smooth, the cab was clean, and the ride to the airport was completely stress-free.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Kulkarni",
    feedback:
      "Traveling to Mumbai Airport was very convenient with this cab service. The driver arrived on time, the vehicle was comfortable, and the journey felt safe and well-managed.",
    rating: 5
  }
];

























const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];










const mumbaiAirportCabJSON = {
  "@context": "https://schema.org",
  "@type": "TouristTrip",
  "name": "Mumbai Airport Cab Service | Velocity Cabs",
  "description": "Book a private cab for Mumbai Airport pickups and drops. AC, SUV, and sedan taxis available for airport transfers, city trips, and outstation travel at affordable fares.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Mumbai, Maharashtra, India"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Mumbai Airport Cab Packages",
    "itemListElement": [
      {
        "@type": "Offer",
        "name": "One Way Mumbai Airport Cab",
        "description": "Private cab service from Mumbai Airport for one-way travel with AC/SUV/Sedan options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      },
      {
        "@type": "Offer",
        "name": "Round Trip Mumbai Airport Cab",
        "description": "Comfortable round-trip cab service to and from Mumbai Airport with private AC/SUV/Sedan options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      }
    ]
  }
};








  return (
    <div>
      
<Helmet>
  <title>Mumbai Airport Cab Service | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Book a private cab for Mumbai Airport pickups and drops. AC, SUV, and sedan taxis available for airport transfers, city trips, and outstation travel at affordable fares."
  />
  <script type="application/ld+json">
    {JSON.stringify(mumbaiAirportCabJSON)}
  </script>
</Helmet>

 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/87.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaiairportcabservice;